<template>
  <MarketCard class="market-insights">
    <CardHeader :eventId="eventId" />

    <EventName
      :class="[classes.eventName, 'event-name']"
      :marketId="marketId"
      :eventId="eventId"
    />

    <div :class="[classes.marketInsightWrapper]">
      <PromoFittedText
        :promoText="insightText"
        alignment="center"
        justifyContent="center"
      ></PromoFittedText>
    </div>

    <MarketName :class="classes.marketName" :marketId="marketId" />

    <div :class="classes.oddsButtonWrapper">
      <template v-if="relevantOption">
        <RelevantButton
          :class="[classes.oddsButton]"
          :option="relevantOption"
          :eventId="eventId"
        ></RelevantButton>
      </template>
      <template v-else>
        <Button
          :stagger="0"
          :class="[classes.oddsButton]"
          :option="firstOption"
        />
        <Button
          :stagger="2"
          :class="[classes.oddsButton]"
          :option="secondOption"
        />
      </template>
    </div>
  </MarketCard>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import MarketCard from "../../styled/MarketCard.vue";
import CardHeader from "../../CardHeader.vue";
import EventName from "../../EventName.vue";
import PromoFittedText from "../../PromoFittedText.vue";
import Button from "./Button.vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";

import MarketName from "../../MarketName.vue";
import { useInsightData } from "../../../hooks/useInsightData";
import RelevantButton from "./RelevantButton.vue";

const { useStyles } = createUseStyles({
  marketName: {
    fontSize: "10px",
    textAlign: "center",
    marginTop: "4px"
  },
  eventName: {
    alignSelf: "center",
    margin: "8px 0",

    "&.competitors": {
      "& > .team-name": {
        fontSize: "16px"
      }
    }
  },
  marketInsightWrapper: {
    flex: "1 1 0",
    minHeight: "0px",
    padding: "3px 10px 0 10px",
    overflow: "hidden",
    boxSizing: "border-box",
    flexDirection: "column",
    display: "flex"
  },
  oddsButton: {
    flex: 1,
    height: "46px",
    "& .odds-text": {
      fontSize: "14px"
    },
    "&:first-of-type": {
      marginRight: "4px"
    },
    "&:last-of-type": {
      marginLeft: "4px"
    }
  },
  oddsButtonWrapper: {
    display: "flex",
    padding: "8px",
    paddingTop: "6px"
  },
  resize: {
    pointerEvents: "none",
    zIndex: -99
  }
});

export default defineComponent({
  name: "InsightCardBadges",
  components: {
    MarketCard,
    CardHeader,
    EventName,
    PromoFittedText,
    Button,
    MarketName,
    RelevantButton
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const { classesRef } = useStyles(ref({}));
    const {
      insightText,
      firstOption,
      secondOption,
      relevantOption
    } = useInsightData(props.marketId);

    return {
      insightText,
      classes: classesRef,
      firstOption,
      secondOption,
      relevantOption
    };
  }
});
</script>
